import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgQuestionmark = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fill: "#000",
		d: "M4 7.25a.75.75 0 0 0 1.5 0H4Zm5.25 8a.75.75 0 0 0 1.5 0h-1.5Zm1.5 2.5a.75.75 0 0 0-1.5 0h1.5Zm-1.5.5a.75.75 0 0 0 1.5 0h-1.5Zm-4.5-11h.75C5.5 4.4 7.528 2.5 10 2.5V1C6.673 1 4 3.6 4 7.25h.75ZM10 1.75v.75c2.472 0 4.5 1.9 4.5 4.75H16C16 3.6 13.327 1 10 1v.75Zm5.25 5.5h-.75c0 1.382-1.003 2.684-2.416 3.626l.416.624.416.624C14.503 11.066 16 9.368 16 7.25h-.75ZM12.5 11.5l-.416-.624c-.772.515-1.484 1.073-2 1.773-.532.722-.834 1.565-.834 2.601h1.5c0-.714.198-1.246.541-1.711.36-.488.897-.93 1.625-1.415L12.5 11.5ZM10 17.75h-.75v.5h1.5v-.5H10Z"
	})]
});
const ForwardRef = forwardRef(SvgQuestionmark);
export { ForwardRef as ReactComponent };
